"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
class Request {
    constructor({ url, method, headers, postData, hasPostData, mixedContentType, initialPriority, referrerPolicy, isLinkPreload, isSameSite, }) {
        const urlObj = new URL(url);
        this.url = url;
        this.urlFragment = urlObj.hash;
        this.method = method;
        this.headers = headers;
        this.postData = postData;
        this.hasPostData = hasPostData;
        this.mixedContentType = mixedContentType;
        this.initialPriority = initialPriority;
        this.referrerPolicy = referrerPolicy;
        this.isLinkPreload = isLinkPreload;
        this.isSameSite = isSameSite;
    }
}
exports.Request = Request;
